import React from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import Icon from "../Icon";
import RcsIcon from "../icons/RcsIcon";
import WAIcon from "../icons/WAIcon";

const DropDownCustom = (props) => {
  const { title = "", options = [], onChange, bodyTitle = "" } = props;

  const _onChange = (item) => {
    if (onChange) {
      onChange(item);
    }
  };

  const iconRender = (icon) => {
    if (icon === "rcs") {
      return <RcsIcon />;
    }

    if (icon === "whatsapp") {
      return <WAIcon />;
    }

    return <Icon icon={icon} />;
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="primary"
        id="dropdown-basic"
        className="!flex items-center gap-2 px-4 py-2 rounded-lg"
      >
        <Icon icon="add" color="white" />
        <span className="text-white text-sm font-medium">{title}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {bodyTitle && (
          <Dropdown.Header className="text-gray-500 font-semibold">
            {bodyTitle}
          </Dropdown.Header>
        )}

        {options.map((item, index) => (
          <Dropdown.Item
            key={index}
            onClick={() =>
              _onChange({
                visible: true,
                type: item.icon,
                data: null,
                key: item.key || null,
              })
            }
          >
            <div className="flex items-center  gap-3">
              <span className="w-5 h-5 flex items-center justify-start">
                {item.icon && iconRender(item.icon)}
              </span>
              <span className="text-sm">{item.label}</span>
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

DropDownCustom.propTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
  bodyTitle: PropTypes.string,
};

export default DropDownCustom;
